(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').normalize('NFKD').toLowerCase()
      .replace(/[\u0300-\u036f]/g, '').replace(/\band\b/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function matches(record, query) {
    var normalized = normalize(query).slice(0, 160);
    if (!normalized) return true;
    var compact = normalized.replace(/\s/g, '');
    var skuQuery = compact.match(/^xls(\d{3,4})(?:(\d{1,2})pack)?$/);
    if (skuQuery) {
      var sku = normalize(record.sku).replace(/\s/g, '');
      return skuQuery[2] ? sku === 'xls' + skuQuery[1] + skuQuery[2] + 'pack'
        : normalize(record.sku.split(' ')[0]).replace(/\s/g, '') === 'xls' + skuQuery[1];
    }
    var spaced = normalize(record.search);
    var haystack = spaced.replace(/\s/g, '');
    return normalized.split(/\s+/).every(function (token) {
      if (/^\d+$/.test(token)) return new RegExp('(^|[^0-9])' + token + '([^0-9]|$)').test(spaced);
      return haystack.includes(token);
    });
  }

  function daysRemaining(deadline, now) {
    return Math.max(0, Math.ceil((Date.parse(deadline) - now) / 86400000));
  }

  if (typeof module === 'object' && module.exports) module.exports = { normalize: normalize, matches: matches, daysRemaining: daysRemaining };
  if (typeof document === 'undefined') return;

  var initialized = new WeakSet();
  var defaults = {
    showing: 'Showing __VISIBLE__ of __TOTAL__ filters',
    showAll: 'Show all __COUNT__ filters', showFewer: 'Show fewer',
    daysLeft: '__COUNT__ days left', dayLeft: '1 day left',
    partnerDeadline: 'Orders due Nov. 30 · __COUNT__ days left', partnerDeadlineDay: 'Orders due Nov. 30 · 1 day left',
    closed: '2027 Early Buy orders closed', closedShort: 'Closed',
    closedCaption: 'Contact us about your 2027 order'
  };

  function labelsFor(root) {
    try { return Object.assign({}, defaults, JSON.parse(root.dataset.ebLabels || '{}')); }
    catch (_) { return defaults; }
  }

  function refreshDeadline(root) {
    var labels = labelsFor(root);
    var days = daysRemaining(root.dataset.ebDeadline, Date.now());
    if (!Number.isFinite(days)) return;
    root.querySelectorAll('[data-eb-days]').forEach(function (el) { el.textContent = days > 0 ? String(days) : labels.closedShort; });
    root.querySelectorAll('[data-eb-days-label]').forEach(function (el) { el.textContent = days > 0 ? (days === 1 ? labels.dayLeft : labels.daysLeft.replace('__COUNT__', days)) : labels.closed; });
    root.querySelectorAll('[data-eb-partner-deadline]').forEach(function (el) { el.textContent = days > 0 ? (days === 1 ? labels.partnerDeadlineDay : labels.partnerDeadline.replace('__COUNT__', days)) : labels.closed; });
    if (!days) root.querySelectorAll('[data-eb-deadline-caption]').forEach(function (el) { el.textContent = labels.closedCaption; });
  }

  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    refreshDeadline(root);
    var input = root.querySelector('[data-eb-query]');
    if (!input) return;
    var labels = labelsFor(root);
    var rows = Array.from(root.querySelectorAll('[data-eb-row]')).map(function (el) {
      return { el: el, sku: el.dataset.ebSku, search: el.dataset.ebSearch };
    });
    var status = root.querySelector('[data-eb-count]');
    var empty = root.querySelector('[data-eb-empty]');
    var toggle = root.querySelector('[data-eb-toggle]');
    var clear = root.querySelector('[data-eb-clear]');
    var expanded = false;
    var countTimer;

    function render(immediate) {
      var query = input.value;
      var searching = Boolean(normalize(query));
      var filtered = rows.filter(function (row) { return matches(row, query); });
      var visible = new Set((searching || expanded ? filtered : filtered.slice(0, 10)).map(function (row) { return row.el; }));
      rows.forEach(function (row) { row.el.hidden = !visible.has(row.el); });
      empty.hidden = filtered.length > 0;
      toggle.hidden = searching || rows.length <= 10;
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? labels.showFewer : labels.showAll.replace('__COUNT__', rows.length);
      clear.hidden = !input.value;
      var text = labels.showing.replace('__VISIBLE__', visible.size).replace('__TOTAL__', filtered.length);
      clearTimeout(countTimer);
      if (immediate) status.textContent = text;
      else countTimer = setTimeout(function () { status.textContent = text; }, 160);
    }

    function reset() { input.value = ''; render(true); input.focus({ preventScroll: true }); }
    input.addEventListener('input', function () { render(false); });
    input.addEventListener('search', function () { render(true); });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value) { event.preventDefault(); reset(); }
      if (event.key === 'Enter') event.preventDefault();
    });
    clear.addEventListener('click', reset);
    toggle.addEventListener('click', function () {
      expanded = !expanded;
      render(true);
      if (!expanded) toggle.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    });
    root.querySelectorAll('[data-eb-controls]').forEach(function (el) { el.hidden = false; });
    root.dataset.ebEnhanced = 'true';
    render(true);
  }

  function initAll() { document.querySelectorAll('[data-ef-eb]').forEach(initialize); }
  function refreshAllDeadlines() { document.querySelectorAll('[data-ef-eb]').forEach(refreshDeadline); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('pageshow', refreshAllDeadlines);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshAllDeadlines(); });
  setInterval(refreshAllDeadlines, 60000);
}());
